import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracoesConsultaLicitacaoCovid: ['administracoes'],
    setAguardandoAberturaConsultaLicitacaoCovid: ['aguardandoAbertura'],
    setSituacaoPesquisaConsultaLicitacaoCovid: ['situacaoPesquisa'],
    setTipoCompraConsultaLicitacaoCovid: ['tipoCompra'],
    setExercicioLicitacaoConsultaLicitacaoCovid: ['exercicioLicitacao'],
    setNumeroLicitacaoConsultaLicitacaoCovid: ['numeroLicitacao'],
    setModalidadeConsultaLicitacaoCovid: ['modalidade'],
    setObjetoConsultaLicitacaoCovid: ['objeto'],
    setDataAberturaInicialConsultaLicitacaoCovid: ['dataAberturaInicial'],
    setDataAberturaFinalConsultaLicitacaoCovid: ['dataAberturaFinal'],
    setObjetoLicitacaoConsultaLicitacaoCovid: ['objetoLicitacao'],
    limpaFiltroConsultaLicitacaoCovid: [],
    receberFiltroConsultaLicitacaoCovid: ['filtroRecebido'],
    setStatusConsultaLicitacaoCovid: ['status'],
})

const INITIAL_STATE = {
    administracoes: [],
    aguardandoAbertura: [],
    tipoCompra: { label: 'Covid-19', value: 2 },
    situacaoPesquisa: '',
    exercicioLicitacao: '',
    numeroLicitacao: '',
    modalidade: [],
    objeto: '',
    dataAberturaInicial: '',
    dataAberturaFinal: '',
    objetoLicitacao: [],
    status: { label: '', value: '' },
}

const setAdministracoes = (state = INITIAL_STATE, action) => {
    return { ...state, administracoes: action.administracoes }
}

const setAguardandoAbertura = (state = INITIAL_STATE, action) => {
    return { ...state, aguardandoAbertura: action.aguardandoAbertura }
}

const setSituacaoPesquisa = (state = INITIAL_STATE, action) => {
    return { ...state, situacaoPesquisa: action.situacaoPesquisa }
}

const setTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: action.tipoCompra }
}

const setExercicioLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacao: action.exercicioLicitacao }
}

const setNumeroLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacao: action.numeroLicitacao }
}

const setModalidade = (state = INITIAL_STATE, action) => {
    return { ...state, modalidade: action.modalidade }
}

const setDataAberturaInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataAberturaInicial: action.dataAberturaInicial }
}

const setDataAberturaFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataAberturaFinal: action.dataAberturaFinal }
}

const setObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: action.objeto }
}

const setObjetoLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, objetoLicitacao: action.objetoLicitacao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACOES_CONSULTA_LICITACAO_COVID]: setAdministracoes,
    [Types.SET_AGUARDANDO_ABERTURA_CONSULTA_LICITACAO_COVID]: setAguardandoAbertura,
    [Types.SET_SITUACAO_PESQUISA_CONSULTA_LICITACAO_COVID]: setSituacaoPesquisa,
    [Types.SET_TIPO_COMPRA_CONSULTA_LICITACAO_COVID]: setTipoCompra,
    [Types.SET_EXERCICIO_LICITACAO_CONSULTA_LICITACAO_COVID]: setExercicioLicitacao,
    [Types.SET_NUMERO_LICITACAO_CONSULTA_LICITACAO_COVID]: setNumeroLicitacao,
    [Types.SET_MODALIDADE_CONSULTA_LICITACAO_COVID]: setModalidade,
    [Types.SET_OBJETO_CONSULTA_LICITACAO_COVID]: setObjeto,
    [Types.SET_DATA_ABERTURA_INICIAL_CONSULTA_LICITACAO_COVID]: setDataAberturaInicial,
    [Types.SET_DATA_ABERTURA_FINAL_CONSULTA_LICITACAO_COVID]: setDataAberturaFinal,
    [Types.SET_OBJETO_LICITACAO_CONSULTA_LICITACAO_COVID]: setObjetoLicitacao,
    [Types.LIMPA_FILTRO_CONSULTA_LICITACAO_COVID]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_LICITACAO_COVID]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_LICITACAO_COVID]: setStatus,
})
